class Overlay {
    static nextOverlayId = 1;
    static nextOverlayZIndex = 11000;
    static overlayBackdropElement;
    static openOverlays = 0;

    overlayId;
    isOpen = false;
    overlayContainer;
    overlayUrl;

    constructor(content, overlayUrl, open = true) {
        this.overlayId = Overlay.nextOverlayId++;
        this.overlayUrl = overlayUrl;
        this.createOverlay(content);
        this.toggle(open);
    }

    createOverlay(content) {
        this.createBackdrop();
        this.overlayContainer = document.createElement('div');
        this.overlayContainer.classList.add('overlay-container');
        document.querySelector('body').appendChild(this.overlayContainer);
        content.classList.add('overlay-content');
        this.overlayContainer.appendChild(content);
        this.createCloseBtn();
        document.dispatchEvent(new CustomEvent('overlay-created', {
            detail: {
                overlayContainer: this.overlayContainer,
            },
        }));
    }

    createBackdrop() {
        if (Overlay.overlayBackdropElement) {
            return;
        }
        Overlay.overlayBackdropElement = document.createElement('div');
        Overlay.overlayBackdropElement.classList.add('overlay-backdrop');
        document.querySelector('body').appendChild(Overlay.overlayBackdropElement);
    }

    createCloseBtn() {
        const closeBtnElement = document.createElement('button');
        closeBtnElement.classList.add('close-button');
        closeBtnElement.ariaLabel = 'Close';
        closeBtnElement.addEventListener('click', () => {
            this.close();
        });
        const closeBtnParent = this.overlayContainer.querySelector('.overlay-content main') ?? this.overlayContainer;
       closeBtnParent.appendChild(closeBtnElement);
    }

    toggle(open = !this.isOpen) {
        if (open) {
            this.open();
        } else {
            this.close();
        }
    }

    open() {
        if(!this.isOpen) {
            Overlay.openOverlays++;
        }
        this.isOpen = true;
        this.overlayContainer.classList.remove('out');
        this.overlayContainer.classList.add('open');
        this.overlayContainer.style.zIndex = Overlay.nextOverlayZIndex++;
        document.querySelector('html').classList.add('overlay-open');
        this.overlayContainer.querySelector('.overlay-content').scrollTo(0, 0);
        Overlay.overlayBackdropElement.classList.remove('out');
        Overlay.overlayBackdropElement.classList.add('open');
         window.history.pushState({}, '', this.overlayUrl);
    }

    close() {
        this.isOpen = false;
        Overlay.openOverlays--;
        this.overlayContainer.classList.add('out');
        this.overlayContainer.classList.remove('open');
        if (Overlay.openOverlays === 0) {
            document.querySelector('html').classList.remove('overlay-open');
            Overlay.overlayBackdropElement.classList.add('out');
            Overlay.overlayBackdropElement.classList.remove('open');
        }
       window.history.back();
    }
}

const loadedOverlayContents = {};

function displayOverlay(linkHref, overlayContent) {
   return new Overlay(overlayContent, linkHref);
}

function fetchOverlayHtml(linkElement) {
    return fetch(linkElement.href)
        .then((response) => response.text());
}

/**
 * Prevent refetching by storing fetched overlays.
 * @param linkElement
 */
async function openOverlay(linkElement) {
   let overlayHtml = loadedOverlayContents[linkElement.href];
   if (!overlayHtml) {
      overlayHtml = await fetchOverlayHtml(linkElement);
   }
   loadedOverlayContents[linkElement.href] = overlayHtml;
   const overlayContentElement = new DOMParser().parseFromString(overlayHtml, 'text/html').querySelector(linkElement.dataset.overlay);
   displayOverlay(linkElement.href, overlayContentElement);
}

function initializeOverlays(rootElement = document) {
    const overlayLinks = rootElement.querySelectorAll('[data-overlay]');
    overlayLinks.forEach((linkElement) => {
        linkElement.addEventListener('click', (event) => {
            event.preventDefault();
            openOverlay(linkElement);
        });
    });
}

window.addEventListener('load', () => {
    initializeOverlays();
});

document.addEventListener('overlay-created', (event) => {
    const overlayContainer = event.detail.overlayContainer;
    initializeOverlays(overlayContainer);
});
